import React from 'react';
import './App.css';
import IntegrationPage from './components/IntegrationPage';

function App() {
  return (
    <div className="App">
      <IntegrationPage />
    </div>
  );
}

export default App;
